import { createTheme, alpha, lighten } from "@mui/material/styles";
import { deepmerge } from "@mui/utils";

const fontFamily = '"Avenir Next", "Helvetica", "Arial", sans-serif';

const adminTheme = (primaryColor, secondaryColor) => ({
  palette: {
    admin: primaryColor,
    primary: {
      main: primaryColor,
      light: lighten(primaryColor, 0.85),
      contrastText: "#fff"
    },
    secondary: {
      main: secondaryColor,
      A200: "#E6F7F7",
      A400: "#ECEBFF"
    },
    body: lighten(primaryColor, 0.9),
    action: {
      hover: alpha(primaryColor, 0.04)
    },
    table: {
      filterRow: "#ffffff"
    }
  },
  gradient: `linear-gradient(90deg, ${primaryColor}, ${secondaryColor})`,
  shape: {
    borderRadius: 0
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontWeight: "bold",
          "&.wide": {
            padding: "6px 28px"
          }
        },
        contained: {
          "&.Mui-disabled": {
            color: "#fff",
            backgroundColor: primaryColor,
            opacity: 0.3
          }
        }
      }
    },
    MuiButtonBase: {
      styleOverrides: {
        root: {
          "&.active": {
            color: "#fff",
            backgroundColor: primaryColor,
            "&:hover": {
              backgroundColor: primaryColor
            }
          }
        }
      }
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.12)"
        }
      }
    },
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontFamily
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        elevation1: {
          boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.12)"
        }
      }
    },
    MuiTab: {
      styleOverrides: {
        root: {
          fontWeight: 700
        }
      }
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          fontFamily
        },
        head: {
          "&:last-child": {
            borderRadius: `0 0px 0 0`
          }
        }
      }
    },
    MuiTabs: {
      styleOverrides: {
        flexContainer: {
          height: 72
        }
      }
    },
    MuiSelect: {
      styleOverrides: {
        iconFilled: {
          color: "rgba(0, 0, 0, 0.54)"
        }
      }
    },
    MuiTypography: {
      styleOverrides: {
        h3: {
          fontWeight: 500
        }
      }
    }
  }
});

const theme = outerTheme => {
  const nestedTheme = createTheme(
    deepmerge(
      outerTheme,
      adminTheme(
        outerTheme.palette.primary.main,
        outerTheme.palette.secondary.main
      )
    )
  );

  return nestedTheme;
};

export default theme;
